/**
 * Submit a beta signup via our /api/beta-signup endpoint.
 *
 * In dev: handled by Vite middleware that runs api/beta-signup.js
 * In prod: handled by Vercel serverless function at /api/beta-signup
 *
 * The API function:
 *  - Validates input
 *  - Inserts to Supabase (using SERVICE_ROLE_KEY, server-side only)
 *  - Sends notification email to admin
 *  - Sends welcome email to the signup
 *
 * @param {Object} data - { name, email, partnerName?, story? }
 * @returns {Promise<{ success: boolean, error?: string }>}
 */
export async function submitBetaSignup({ name, email, partnerName, story }) {
  if (!name?.trim() || !email?.trim()) {
    return { success: false, error: 'Navn og email er påkrævet' };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email.trim())) {
    return { success: false, error: 'Indtast venligst en gyldig email-adresse' };
  }

  try {
    const resp = await fetch('/api/beta-signup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, partnerName, story }),
    });

    const data = await resp.json().catch(() => ({}));

    if (!resp.ok) {
      return { success: false, error: data.error || 'Noget gik galt' };
    }

    return { success: true };
  } catch (err) {
    console.error('Beta signup error:', err);
    return { success: false, error: 'Kunne ikke kontakte serveren — prøv igen om lidt' };
  }
}
